var React = require('react');

var Paginator = React.createClass({
    makeLink: function (text, key, num, specialClass) {
        if (num === this.props.currentPage) {
            return <li className={specialClass ? specialClass + ' disabled' : 'active'} key={key}><span>{text}</span></li>;
        } else {
            return <li className={specialClass} key={key}><a href="#" onClick={this.props.disabled ? null : this.onClick.bind(this, num)}>{text}</a></li>;
        }
    },

    onClick: function (num, e) {
        e.preventDefault();

        this.props.onPageSelected(num);
    },

    propTypes: {
        currentPage: React.PropTypes.number,
        onPageSelected: React.PropTypes.func,
        pageCount: React.PropTypes.number,
        disabled: React.PropTypes.bool
    },

    render: function () {
        var parts = [];

        parts.push(this.makeLink('<', 'prev', Math.max(1, this.props.currentPage - 1), 'prev'));

        // Use three ranges of page numbers. While processing each range, verify that every number is in range
        // and nothing gets rendered twice.
        var ranges = [
            {start: 1, end: 20},
            {start: this.props.currentPage - 2, end: this.props.currentPage + 2},
            {start: this.props.pageCount, end: this.props.pageCount}
        ];

        var lastNumberRendered = 0;
        ranges.forEach(function (range) {
            for (var i = range.start; i <= range.end; i++) {
                if (i < 1 || i > this.props.pageCount || i <= lastNumberRendered) {
                    continue;
                }

                parts.push(this.makeLink(i, i, i));
                lastNumberRendered = i;
            }
        }.bind(this));

        parts.push(this.makeLink('>', 'next', Math.min(this.props.pageCount, this.props.currentPage + 1), 'next'));

        return <div className="dataTables_paginate inline paging_bootstrap">
            <ul className="pagination">
                {parts}
            </ul>
        </div>;
    }
});
module.exports = Paginator;



// WEBPACK FOOTER //
// ./app/components/Paginator/Paginator.js